
import React from 'react';
import { message, Table } from 'antd';
import { isValidArray , isValid, isValidNumber, isValidArrayWithValues } from '../../utils/utilities';
import { getValueFromPercentage, roundNumber } from './../../utils/math.utils';
import { getAPIDateFormat } from '../../utils/date.utils';
import { GET_PASSENGER_DETAILS_BY_PHONE_NUMBER_URL, UPDATE_FARE_FOR_SEAT_AND_ROUTE_SPECIFIC_URL, FETCH_SEAT_LAYOUT_URL } from '../../utils/api-url';
import { postCall } from '../../utils/network.util';
import { SET_SELECTED_SCHEDULE_SEATS, REFRESH_SELECTED_SEATS, SET_SELECTED_TRIP_ROUTES, SET_VIP_TICKET_REASONS } from '../../actions/action-types';
import { loadingAction } from '../../actions/loading-actions';

export const getDetailsToBookTicket=(formValues,selectedSchedule,datetime,isSendPaymentLink,discountValue,oldTicketId=null,sendNotification)=>{
  let ticket={},seats=[],travellers=[], extraSeatsTravellers = [];
    let currentSeatStatus = null;
    ticket.trip_id = selectedSchedule.trip.id;
    ticket.trip_route_id = selectedSchedule.trip.trip_route_id;
    ticket.pickupLocation = formValues.boardingPointId;
    ticket.dropLocation = formValues.dropPointId;
    ticket.emailId = formValues.emailId;
    ticket.travelDate = getAPIDateFormat(selectedSchedule.trip.start_date)
    ticket.phoneNumber = '';
    ticket.oldTicketId = oldTicketId;
    ticket.vip_reason = formValues.vip_reason;
    if(isValid(formValues.phoneNumber)){
      ticket.phoneNumber = formValues.phoneNumber;
    }
    ticket.agent_id = global.agentId;
    let updatedBy = null;
    if(isValid(formValues.agentId)){
      ticket.agent_id = formValues.agentId;
      // ticket.userName = agentsList.find(agent => agent.id === formValues.agentId)?.name || null;
      // ticket.userName = global.userName;
      updatedBy = global.userName;
    }
    // Note : username should not change even for on behalf booking
    ticket.userName = global.userName;
    ticket.updated_by = updatedBy;
    ticket.remarks = formValues.remarks;
    let ticketUIAmount = 0;

    if (isValidArrayWithValues(formValues.passengerDetails)){
      ticket.clientSideDiscount = discountValue;
      formValues.passengerDetails.forEach((passenger)=>{
      let age = 0 , fullName = '';
      if(isValid(passenger.age)){
        age = passenger.age  ;
      }
      if(isValid(passenger.fullName)){
        fullName=passenger.fullName;
      }
      // Note: currentSeatStatus value to handle admin blocked seats.
      if(!isValid(currentSeatStatus) && isValid(passenger.seatStatus) && passenger.seatStatus !== ""){
        currentSeatStatus = passenger.seatStatus;
      }
      ticketUIAmount+=passenger.discountedCostWithGst;
        travellers.push({
            fullName:fullName,
            gender:passenger.gender,
            age:age,
            // vaild only for agent booking for some one else
            updated_by:updatedBy
        });
        seats.push({
          id : passenger.id,
          tripId : selectedSchedule.trip.id,
          ui_fare : passenger.fare,
          seatNumber : passenger.seatNumber,
          ladiesSeat : passenger.gender === "F" ? true : false
        })
      })
    }

    if (isValidArrayWithValues(formValues.extraSeatDetails)) {
      formValues.extraSeatDetails.map((extraSeat) => {
        ticketUIAmount+=extraSeat.extra_fare;
        extraSeatsTravellers.push({
          fullName:extraSeat.extra_fullName,
          gender:isValid(extraSeat.extra_gender)?extraSeat.extra_gender:'M',
          age:isValid(extraSeat.extra_age)?extraSeat.extra_age:0,
          fare: extraSeat.extra_fare,
          remarks: extraSeat.extra_remarks,
          is_extra_seat: true
        });
      })
    }

    ticket['cost'] = ticketUIAmount;

    return {
        ticket: ticket,
        returnTicket: null,
        seats: seats,
        returnSeats: null,
        travellers: travellers,
        extraSeatsTravellers: extraSeatsTravellers,
        websiteBooking: false,
        datetime:datetime,
        isSendPaymentLink:isSendPaymentLink,
        sendNotification:sendNotification,
        currentSeatStatus:currentSeatStatus
      }
}

export const getTicketFare=(seats,clientSideDiscount,bus, extraSeatInfoList)=>{
  let baseFare=0,cgst=0,sgst=0 , discountedCostWithoutGst=0;
  if(isValidArray(seats)&&seats.length>0){
    let discountCostPerSeat = clientSideDiscount/seats.length;
    seats.forEach(element => {
      baseFare=baseFare+element.fare;
      cgst=cgst+element.cgstOfDiscountedPrice;
      sgst=sgst+element.sgstOfDiscountedPrice;
      discountedCostWithoutGst=discountedCostWithoutGst+element.discountedCostWithoutGst-discountCostPerSeat;
      if(isValidNumber(discountedCostWithoutGst)){
        cgst = getValueFromPercentage(discountedCostWithoutGst,bus.cgst_percentage);
        sgst = getValueFromPercentage(discountedCostWithoutGst,bus.sgst_percentage);
      }
    });
  }

  if (isValidArrayWithValues(extraSeatInfoList)) {
    extraSeatInfoList.map((extraSeats) => {
      baseFare=baseFare+extraSeats.extra_fare;
      discountedCostWithoutGst=discountedCostWithoutGst+extraSeats.extra_fare;
      if(isValidNumber(discountedCostWithoutGst)){
        cgst = getValueFromPercentage(discountedCostWithoutGst,bus.cgst_percentage);
        sgst = getValueFromPercentage(discountedCostWithoutGst,bus.sgst_percentage);
      }
    })
  }

  return{
    baseFare:roundNumber(baseFare),
    cgst:roundNumber(cgst),
    sgst:roundNumber(sgst),
    discountedCostWithoutGst:roundNumber(discountedCostWithoutGst),
    totalCost:roundNumber(discountedCostWithoutGst+cgst+sgst)
  }
}



const getBoardingLocation=(boardingPoints,boardingPointId)=>{
  let location ='';
  if(isValidArray(boardingPoints)&&boardingPoints.length>0){
    boardingPoints.forEach((row)=>{
      if(boardingPointId===row.id){
        location=row.location
      }
    })
    return location
  }else{
    return null
  }

}

export const PassengerSeatsTable=({formValues,boardingPoints,discountValue,bus})=>{
  let {
    passengerDetails,
    boardingPointId
  }=formValues;
  let location = getBoardingLocation(boardingPoints,boardingPointId);
  let discountPerSeat = 0; 
  if(isValidNumber(discountValue)&&isValidArrayWithValues(passengerDetails)){
     discountPerSeat = discountValue / passengerDetails.length; 
  }
  let hideGenderFromBooking = global.travelsAppConfig['HIDE_GENDER_FROM_BOOKING']==1;
  let hideAgeFromBooking = global.travelsAppConfig['HIDE_AGE_FROM_BOOKING']==1;
  let hideEmailFromBooking = global.travelsAppConfig['HIDE_EMAIL_FROM_BOOKING']==1;

  let columns = [
    {
      title: 'Seat no',
      dataIndex: 'seatNumber',
      key: 'seatNumber',
    }
  ];
  let combinedTitleName = "Name";
  if(!hideAgeFromBooking){
    combinedTitleName += " Age";
  }
  if(!hideGenderFromBooking){
    combinedTitleName += " Sex";
  }
  columns.push({
    title: combinedTitleName,
    render: (record) => (
      <React.Fragment>
        {record.fullName}
        {!hideAgeFromBooking&&record.age&&<><br />{record.age}</>}
        {!hideGenderFromBooking&&record.gender&&<><br />{record.gender}</>}
      </React.Fragment>
    ),
    responsive: ["xs"]
  });
  columns.push({
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName',
      responsive: ["sm"],  
      render: (fullName) => (
        <div className='passengerName'>
            {fullName}
        </div>
      )
  });
  if (!hideAgeFromBooking) {
    columns.push({
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      responsive: ["sm"]
    });
  }
  if (!hideGenderFromBooking) {
    columns.push({
      title: 'Sex',
      dataIndex: 'gender',
      key: 'gender',
      responsive: ["sm"]
    });
  }
  columns.push({
    title: 'Amount Paid',
    dataIndex: 'discountedCostWithoutGst',
    key: 'discountedCostWithoutGst',
    render : (text, record, index) => {
        let discountedCostWithoutGst = record.discountedCostWithoutGst - discountPerSeat; 
        let cgstOfDiscountedPrice = 0;
        let sgstOfDiscountedPrice = 0;
        if(isValidArray(bus)){
          cgstOfDiscountedPrice = getValueFromPercentage(discountedCostWithoutGst,bus.cgst_percentage);
          sgstOfDiscountedPrice = getValueFromPercentage(discountedCostWithoutGst,bus.sgst_percentage);
        }
        return roundNumber(discountedCostWithoutGst+cgstOfDiscountedPrice+sgstOfDiscountedPrice);
    }
  });

  columns.push({
    title: 'Boarding',
    render: (record) => (
        <React.Fragment>
          {location}
        </React.Fragment>
      ),
    key: 'Boarding',
  });

  if(isValidArray(passengerDetails)){
    return <Table dataSource={passengerDetails} columns={columns} pagination={false}/>
  }else{
    return null
  }
}


export const getAnyBlockedSeatsExit=(seats)=>{
  let bool = false;
    if(isValidArray(seats)&&seats.length){
      seats.forEach(element => {
        if(element.seatStatus==="Blocked"){
          bool=true;
        }
      });

    }
  return bool;
}

// Note: Book / Block / Release / Send Payment Link actions must be hidden if any selected seat
// is Blocked and belongs to OTA / Prepaid-OTA / Website.
// ticketAgentPrivilege is unified in getFormatedSeatObject (top-level seat or seatShownPassenger in cutroute).
const RESTRICTED_AGENT_PRIVILEGES = ["OTA", "Prepaid-OTA", "Website"];
export const hasRestrictedPrivilegeBlockedSeat=(seats)=>{
  if(!isValidArray(seats) || seats.length === 0){
    return false;
  }
  return seats.some(element =>
    element.seatStatus === "Blocked"
    && RESTRICTED_AGENT_PRIVILEGES.includes(element.ticketAgentPrivilege)
  );
}

export const getPassengerDetailsByPhoneNumber=(phoneNumber,onSuccess=()=>{})=>{
  if(isValidNumber(phoneNumber)){
    let data = {
      phoneNumber: phoneNumber
    }
    postCall(GET_PASSENGER_DETAILS_BY_PHONE_NUMBER_URL, data).then((res)=>{
      if(isValid(res.payload)&&res.payload.Status == "SUCCESS"){
        let {
          ticketDetails,
          travellerDetails
        } = res.payload.Payload;
        onSuccess(ticketDetails,travellerDetails);
      }else{
        message.warning(res.payload.Message);
      }
    }).catch((error)=>{
      console.error(error);
      message.warning("Unable to fetch passenger details.Please try again later.");
    }) 
  }else{
    message.warning("Please enter phone number");
  }
}

export const getTravellerDetails=(travellers,travellerIndex)=>{
  let traveller = travellers[travellerIndex];
  if (isValid(traveller)) {
    return traveller;
  }
  return null;
}

export const handleFareChange = (updatedFares, selectedSchedule, dispatch, isVip = false) => {
  // Build fareJson with SS_seatNumber or VIP_seatNumber format based on isVip flag
  const fareJson = {};
  const prefix = isVip ? `VIP_${global.agentId}_` : 'SS_';
  updatedFares.forEach(updatedFare => {
    fareJson[`${prefix}${updatedFare.seatNumber}`] = updatedFare.fare;
  });
  
  // Set loading true before API call
  dispatch(loadingAction(true));
  
  // Call API to update fare
  const tripRouteId = selectedSchedule.trip_route_id;
  postCall(UPDATE_FARE_FOR_SEAT_AND_ROUTE_SPECIFIC_URL, {
    tripRouteId: tripRouteId,
    fareJson: fareJson,
    updatedBy: global.userName
  }).then((response) => {
    if (response.status === "SUCCESS" && response.payload.Status === "SUCCESS") {
      message.success("Fare updated successfully");
      // Refetch seats and merge new values with selected seats
      postCall(FETCH_SEAT_LAYOUT_URL, {
        tripRouteId: tripRouteId,
        isPassengerInfoNeeded: global.privilege === 'Redbus' ? false : true,
        agentId: global.agentId,
        operatorCode: global.operatorCode
      }).then((seatResponse) => {
        dispatch(loadingAction(false));
        if (seatResponse.status === "SUCCESS" && seatResponse.payload.Status === "SUCCESS") {
          const freshSeats = seatResponse.payload.Payload.seats || [];
          // Update selectedScheduleSeats in home reducer
          dispatch({
            type: SET_SELECTED_SCHEDULE_SEATS,
            payload: freshSeats
          });
          dispatch({
            type: SET_SELECTED_TRIP_ROUTES,
            payload: seatResponse.payload.Payload.tripRoute
          });
          if (isValid(seatResponse.payload.Payload.vipTicketReasons)) {
            dispatch({
              type: SET_VIP_TICKET_REASONS,
              payload: seatResponse.payload.Payload.vipTicketReasons
            });
          }
          // Update selectedSeats in passenger-form reducer (preserves form data)
          dispatch({
            type: REFRESH_SELECTED_SEATS,
            payload: { freshSeats }
          });
        }
      }).catch((err) => {
        dispatch(loadingAction(false));
        console.error("Error refetching seats:", err);
      });
    } else {
      dispatch(loadingAction(false));
      message.error(response.payload?.Message || "Failed to update fare");
    }
  }).catch((error) => {
    dispatch(loadingAction(false));
    console.error("Error updating fare:", error);
    message.error("Failed to update fare");
  });
}